<script setup lang="ts">
import { onBeforeUnmount, onMounted, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import LegalGate from '@/components/LegalGate.vue';
import { useAuthStore } from '@/stores/auth';

const { t, locale } = useI18n();
const router = useRouter();
const route = useRoute();
const auth = useAuthStore();

// Заголовок вкладки и lang документа следуют за языком интерфейса.
watchEffect(() => {
  document.title = t('app.name');
  document.documentElement.lang = locale.value;
});

// Перехватчик axios не знает про роутер: когда refresh не удался, он шлёт событие, а мы ведём на вход.
function onAuthExpired() {
  if (route.name === 'login') return;
  void router.replace({ name: 'login', query: route.path === '/' ? {} : { redirect: route.fullPath } });
}
onMounted(() => window.addEventListener('auth:expired', onAuthExpired));
onBeforeUnmount(() => window.removeEventListener('auth:expired', onAuthExpired));
</script>

<template>
  <RouterView />
  <LegalGate v-if="auth.isAuthenticated && auth.pendingLegal.length > 0" />
</template>
